import { useMemo } from 'react';

import { NftMintSteps } from '@app/client';
import { useMintingOverlayStore } from '@app/store/zustand';
import { useEmojisStore } from '@app/store/zustand/emojis/useEmojisStore';

export function useMintStep(): NftMintSteps {
    const { mintingInitiated, mintingFailed, renaming, mintingSuccess } = useMintingOverlayStore();
    const { loadingVisualized, visualizerFiles, visualizerMetadata, currentEmojiMinted, visualizerIsLocked } =
        useEmojisStore();

    const canMint =
        !mintingInitiated && !currentEmojiMinted && visualizerFiles?.video && !loadingVisualized && !mintingFailed;
    const loading = canMint && (loadingVisualized || visualizerIsLocked === null);
    const canRename = currentEmojiMinted && renaming;
    const notVisualised = !loadingVisualized && (!visualizerMetadata || !visualizerFiles?.video);
    const visualiserProcessing = visualizerMetadata && !visualizerFiles?.video;

    return useMemo(() => {
        if (mintingInitiated && !mintingSuccess) {
            return NftMintSteps.LoadingMint;
        }
        if (loading) {
            return NftMintSteps.Loading;
        }
        if ((currentEmojiMinted || mintingSuccess) && !renaming) {
            return NftMintSteps.Complete;
        }

        if (visualiserProcessing) {
            return NftMintSteps.Processing;
        }
        if (notVisualised) {
            return NftMintSteps.YatNotVisualized;
        }
        if (canMint) {
            return NftMintSteps.Introduction;
        }

        if (canRename) {
            return NftMintSteps.RenameNft;
        }

        if (mintingFailed) {
            return NftMintSteps.Error;
        }
        return NftMintSteps.Introduction;
    }, [
        canMint,
        canRename,
        currentEmojiMinted,
        loading,
        mintingFailed,
        mintingInitiated,
        mintingSuccess,
        notVisualised,
        renaming,
        visualiserProcessing,
    ]);
}
